import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BIPOC from '../../assets/images/home/BIPOC.jpg';
import Andropause from '../../assets/images/home/Andropause.jpg';
import Fertility from '../../assets/images/home/Fertility.jpg';
import BehavioralHealth from '../../assets/images/home/Behavioral_Health.jpg';
import CaregiverSupport from '../../assets/images/home/Caregiver_Support.jpg';
import ChildDevelopment from '../../assets/images/home/Child_Development.jpg';
import Maternity from '../../assets/images/home/Maternity.jpg';
import Menopause from '../../assets/images/home/Menopause.jpg';
import Nutrition from '../../assets/images/home/Nutrition.jpg';
import Preconception from '../../assets/images/home/Preconception.jpg';
import Surrogacy from '../../assets/images/home/surrogacy.jpg';
import Adoption from '../../assets/images/home/adoption.jpg';
import WomensHealth from '../../assets/images/home/Womens_Health.jpg';
import WINforHim from '../../assets/images/home/WIN_for_Him.jpg';
import LGBTQIA from '../../assets/images/home/LGBTQIA.jpg';
import Doulas from '../../assets/images/home/Doulas.jpg';
import GenderAfirm from '../../assets/images/home/Gender.png';
import { useTranslation } from 'react-i18next';
import { useChat } from '../Layout/ChatContext';
import ChatBotWindow from "../ChatBot/ChatBotWindow";

const AllSupportServices = () => {
  const navigate = useNavigate();
  const [blockData, setBlockData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = useSelector((state) => state.dashboard.dashboardData.ServiceDetails) || [];
  const ssoData = useSelector((state) => state.sso.ssoUserData);
const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const { t, i18n } = useTranslation();
  // Carousel state
  const [itemsPerView, setItemsPerView] = useState(5);
  const [currentPosition, setCurrentPosition] = useState(0);
  const totalItems = blockData.length;
  const scrollCount = 1;
  const { isChatVisible, showChat } = useChat();

  const getServiceImage = (serviceType) => {
    switch (serviceType) {
      case 'LGBTQIA+':
        return LGBTQIA;
      case 'BIPOC':
        return BIPOC;
      case 'Maternity':
        return Maternity;
      case 'Fertility':
        return Fertility;
      case 'Preconception':
        return Preconception;
      case 'Behavioral Health':
        return BehavioralHealth;
      case 'Nutrition':
        return Nutrition;
      case 'Child Development':
        return ChildDevelopment;
      case 'Caregiver Support':
        return CaregiverSupport;
      case 'Menopause':
        return Menopause;
      case 'Andropause':
        return Andropause;
      case 'WIN for Him':
        return WINforHim;
      case 'Surrogacy':
        return Surrogacy;
        case 'Adoption':
          return Adoption;
      case "Women's Health":
        return WomensHealth;
        case "Doulas":
          return Doulas;
          case 'Gender-Affirming Support':
                    return GenderAfirm;
      default:
        return console.log("no images found"); // Use a fallback image if service type is unknown
    }
  };
  useEffect(() => {
    setLoading(true); // Start loading

    // Add a small delay to ensure the loading state is visible
    setTimeout(() => {
      if (userData.length > 0) {
        const homeBlockData = userData.map((service) => ({
          id: service.ServiceId,
          image: getServiceImage(service.ServiceDescription), // Use the function to get the corresponding image
          text: service.ServiceDescription,
          link: service.WebLink || "#",
          videolink:service.VideoLink 
        }));
        setBlockData(homeBlockData);
        console.log("Data processed, setting loading to false");
      } else {
        console.log("No userData available, setting loading to false");
      }
      setLoading(false); // Stop loading
    }, 100);
  }, [userData]);

  // Adjust itemsPerView based on window width
  useEffect(() => {
    const updateItemsPerView = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 600) {
        setItemsPerView(1);
      } else if (screenWidth <= 900) {
        setItemsPerView(3);
      } else {
        setItemsPerView(5);
      }
    };

    updateItemsPerView();
    window.addEventListener("resize", updateItemsPerView);
    return () => window.removeEventListener("resize", updateItemsPerView);
  }, []);

  const scrollCarousel = (direction) => {
    const maxPosition = totalItems - itemsPerView;
    let newPosition = currentPosition + direction * scrollCount;

    if (newPosition < 0) {
      newPosition = 0;
    }

    if (newPosition > maxPosition) {
      newPosition = maxPosition;
    }

    setCurrentPosition(newPosition);
  };

  const offset = (currentPosition * 100) / itemsPerView;

  const handleCarouselClick = (link) => {
    const updatedLink = {
      ...link,
      originalText: link.text, // Always preserve original
      displayText: (isHighmarkPortal && link.text === "WIN for Him")
        ? "Fertility and Family Building for Him"
        : link.text
    };
  
    navigate('/support-services', { state: updatedLink });
  };
  const handleBackClick = () => {
    navigate('/home'); // Redirects to the home page
  };
  const getImageClass = (imagePath) => {
    if (!imagePath) return '';
    const name = imagePath.split('/').pop().split('.')[0]; // e.g., Fertility.jpg → Fertility
    return `img-${name.replace(/\s+/g, '-').toLowerCase()}`; // kebab-case
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  
  return (
    <>
    {isHighmarkPortal ?
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">Support</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">Support</h2>
        </div>
      }
    {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
    <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t("Back")}</span></button>
    </div> */}
      <div className="carousel-container mt-2">
        <div
          className="home-carousel-inner no-carousel"
          style={{ transform: `translateX(-${offset}%)` }}
        >
          {blockData.map((block) => (
            <div
              key={block.id}
              className="home-carousel-item"
              onClick={() => handleCarouselClick(block)} // Trigger click event
              style={{ cursor: "pointer" }} // Change cursor to indicate clickability
            >
                 <div className={`carousel-image ${getImageClass(block.image)}`} />
              {/* <img
                src={block.image}
                alt={`Image for ${block.text}`}
                className="carousel-image"
              /> */}
         <div className="carousel-text">
  {(isHighmarkPortal && block.text === "WIN for Him")
    ? "Fertility and Family Building for Him"
    : block.text}
</div>

            </div>
          ))}
        </div>
        {/* <div className="home-carousel-controls">
          <button
            className="btn btn-custom-carousel-arrows btn-left-arrow"
            onClick={() => scrollCarousel(-1)}
            disabled={currentPosition === 0}
          />
          <button
            className="btn btn-custom-carousel-arrows btn-right-arrow"
            onClick={() => scrollCarousel(1)}
            disabled={currentPosition >= totalItems - itemsPerView}
          />
        </div> */}
      </div>
      {/* Chat button */}
      {/* <div className="floating-chat-button" onClick={showChat}>
        💬
      </div> */}

      {/* Render ChatWindow conditionally */}
      {/* {isChatVisible && <ChatBotWindow />} */}
    </>
  );
};

export default AllSupportServices;
